import { Injectable } from '@angular/core';
import { CFHttpClient } from '../shared/cf-http-client';
import { environment } from '../../environments/environment';
import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';
import { UtilService } from '@mem-shared/util.service';
import { UserSession } from '../shared/user-session';

// const getZipariBearerToken = '/mas/sec/getBearerToken.json';
const getBearerToken = environment.serviceSecuredURLs.zipariBearerTokenURL;
let sessionToken;

@Injectable()
export class zipariLoginService {

    constructor(private http: CFHttpClient,
        private utilSvc: UtilService,
        public userSession: UserSession) {
    }

    getTokenZipariLogin(portal) {
        let params = {
            clientId: this.getClientID(portal)
        };
        return this.http.get(getBearerToken, params);
    }

    newLogin(token, portal, baseUrl, environmentUrl) {
         let headers = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded'

        });
        
        let options = {
            headers: headers
        };
   
        const newloginUrl = `${baseUrl}/login/sessionCookieRedirect?token=${token}&redirectUrl=${environmentUrl}/login/v2/jwt/${this.getClientID(portal)}`;
       
        return this.http.get(newloginUrl, options);
        
    }

    getClientID(portal) {
        const env = this.utilSvc.getEnvName();
        const zenv = this.userSession.getLocalStorageItem('zenv');//zenv set from selfservice app
        let client_id;

        if (portal == 'MEMBER') {
            if (env === 'dev') {
                client_id = 'ZMxTpNcXYPFHm8bHMFwy';
            } else if (env === 'tt') {
                client_id = 'oMMNJTZ5iOL3NaUQHsVM';
            } else if (env === 'sita') {
                client_id = 'MXrJwnJdSTkWtaYYOCAW';
            } else if (env === 'uat') {
                client_id = 'EjLKaQ5ePxUH6P3pmKor';
            } else {
                client_id = 'kbqVWQCHk4glEaGU0GiW';
            }
            return client_id;
        }

        if (portal == 'SHOPPER') {
            if (env === 'dev') {
                client_id = 'J9m9ygS6G4T1G11ocWyK';
            } else if (env === 'sita') {
                client_id = 'g46x7hvQBnRW6KB3s7mF';
            } else if (env === 'uat') {
                client_id = 'oeVYL9sR9NBOYAhlNzpZ';
            } else if (env === 'tt') {
                if (zenv && zenv === 'sit') {
                    client_id = 'g46x7hvQBnRW6KB3s7mF';
                }
                else {
                    client_id = 'shop-tt-u2YiYPmDUTu4MvHGE2q9';
                }
            } else {
                client_id = 'DHW5rlt5yKDBkgyJKDts';
            }
            return client_id;
        }
    }

}




// WEBPACK FOOTER //
// ./src/app/shared/zipariLogin.service.ts